// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FB0O","type":"styles_type__2wz99","choices":"styles_choices__296x5"};